import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="wrap flex min-h-[80vh] flex-col items-start justify-center pt-24">
      <p className="outline-text font-display text-[30vw] font-black leading-none lg:text-[18vw]">404</p>
      <h1 className="display-lg mt-4">Wrong turn.</h1>
      <p className="mt-4 max-w-md text-slate-400">The page you're looking for isn't here. Head back to the showroom.</p>
      <Link to="/" className="btn-crimson mt-8"><ArrowLeft className="h-4 w-4" /> Back home</Link>
    </section>
  );
}
